import * as yup from 'yup'

const EMAIL_TOO_LONG = 'Email is too long'
const EMAIL_INVALID = 'Email must be valid'
const EMAIL_NEEDS_DOMAIN_SUFFIX = 'Email must include a domain suffix (e.g. .com or .ca)'

function emailStringSchema() {
  return yup
    .string()
    .trim()
    .max(254, EMAIL_TOO_LONG)
    .email(EMAIL_INVALID)
    .matches(/\.[a-zA-Z]{2,}$/, {
      message: EMAIL_NEEDS_DOMAIN_SUFFIX,
      excludeEmptyString: true
    })
}

const emailYup = () => emailStringSchema()

const optionalEmailYup = () => emailStringSchema()

export { emailYup, optionalEmailYup }
